import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Observable } from 'rxjs';


@Component({
    selector: 'aa-quick-switch',
    templateUrl: './quick-switch.component.html',
    styleUrls: [
        './quick-switch.component.scss'
    ],
    standalone: false
})
export class QuickSwitchComponent
{
    @Input() keyTrad: string;
    @Input() state: Observable<boolean>;
    @Output() quickSwitchToggled: EventEmitter<boolean> = new EventEmitter<boolean>();

    public onToggleQuickSwitch (qsState: boolean)
    {
        this.quickSwitchToggled.emit(qsState);
    }
}
